module.exports = __webpack_public_path__ + "static/img/jclb3.616d5e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jclb3.png
// module id = uLNk
// module chunks = 1